<template>
  <v-layout pt-4>
    <v-flex>
      <v-form action.prevent="">
        <v-card>
          <v-layout align-center column>
            <v-flex xs10>
              <content-editor
                label="Edit Email Template"
                v-model="emailTemplate"
              />
            </v-flex>

            <v-flex xs3>
              <v-btn
                color="success"
                @click="submitForm"
              >Update settings
              </v-btn>
            </v-flex>

          </v-layout>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>


</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { escaping, unescaping } from '@/utils/emailTemplates'

  export default {
    name: "editEmailTemplate",
    data() {
      return {
        emailTemplate: ''
      }
    },
    computed: {
      ...mapGetters([
        'emailTemplateLayout'
      ])
    },
    methods: {
      ...mapActions([
        'editEmailTemplate'
      ]),
      escaping,
      unescaping,
      async submitForm () {
        const payload = {
          layout: this.escaping(this.emailTemplate)
        }
        await this.editEmailTemplate(payload)
      }
    },
    beforeMount () {
      this.emailTemplate = this.unescaping(this.emailTemplateLayout)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/EmailTemplate/editEmailTemplate.vue